import { gql } from "@apollo/client";

const DELETE_JUSTIFICACION_VISITA = gql`
mutation DeleteJustificacionVisita($idJustificacionVisita: Int!) {
    deleteJustificacionVisita(idJustificacionVisita: $idJustificacionVisita)
}`;

export default DELETE_JUSTIFICACION_VISITA;